// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"ec4d62a4","34":"a3816385","46":"a063665b","157":"75b24fec","181":"86d17555","424":"38daca9d","496":"79aa78c5","658":"ee0e67d5","933":"9ff5fc46"}[chunkId] + ".chunk.js";
};